import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCategory } from './CategoryContext';
import { Button } from 'react-bootstrap';
import '../styles/Search.css';

const SearchComponent = () => {
  const navigate = useNavigate();
  const { items } = useCategory();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const handleSearch = (e) => {
    e.preventDefault();

    if (!searchTerm.trim()) {
      setSearchResults([]);
      return;
    }

    const allData = items.map(item => ({ ...item, url: item.category }));
    const results = allData.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()) || (item.tigerCode && item.tigerCode.toString().includes(searchTerm)));
    
    setSearchResults(results);
    navigate('/search-result', { state: { searchResults: results } });
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <form onSubmit={handleSearch}>
      <div className="search">
    <input type="text" classNameName="search__input" placeholder="Введите запрос" value={searchTerm} onChange={handleInputChange} />
    <button className="search__button">
        <svg className="search__icon" aria-hidden="true" viewBox="0 0 24 24">
            <g>
                <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
            </g>
        </svg>
    </button>
</div>
    </form>
  );
};

export default SearchComponent;